
import { Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { bool_type, record_type, list_type, option_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Auto_generateBoxedDecoder_Z6670B51, fromString } from "../../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { createObj, uncurry2 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { isNullOrWhiteSpace, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, append, singleton, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { singleton as singleton_1, map, isEmpty, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Variant } from "../../Variant.js";

export class ProcedureResultsPrintData extends Record {
    constructor(TemplateName, TemplateDescription, StartDate, EndDate, State, Steps) {
        super();
        this.TemplateName = TemplateName;
        this.TemplateDescription = TemplateDescription;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.State = State;
        this.Steps = Steps;
    }
}

export function ProcedureResultsPrintData_$reflection() {
    return record_type("Procedure.Results.PrintView.ProcedureResultsPrintData", [], ProcedureResultsPrintData, () => [["TemplateName", string_type], ["TemplateDescription", string_type], ["StartDate", string_type], ["EndDate", option_type(string_type)], ["State", string_type], ["Steps", list_type(ProcedureResultsPrintStep_$reflection())]]);
}

export class ProcedureResultsPrintStep extends Record {
    constructor(Name, IsCompleted, Elements) {
        super();
        this.Name = Name;
        this.IsCompleted = IsCompleted;
        this.Elements = Elements;
    }
}

export function ProcedureResultsPrintStep_$reflection() {
    return record_type("Procedure.Results.PrintView.ProcedureResultsPrintStep", [], ProcedureResultsPrintStep, () => [["Name", string_type], ["IsCompleted", bool_type], ["Elements", list_type(ProcedureResultsPrintElement_$reflection())]]);
}

export class ProcedureResultsPrintElement extends Record {
    constructor(Label, Type, Value, SignatureUrl) {
        super();
        this.Label = Label;
        this.Type = Type;
        this.Value = Value;
        this.SignatureUrl = SignatureUrl;
    }
}

export function ProcedureResultsPrintElement_$reflection() {
    return record_type("Procedure.Results.PrintView.ProcedureResultsPrintElement", [], ProcedureResultsPrintElement, () => [["Label", string_type], ["Type", string_type], ["Value", option_type(string_type)], ["SignatureUrl", option_type(string_type)]]);
}

function decodeData(encodedData) {
    try {
        const json = new TextDecoder('utf-8').decode(Uint8Array.from(atob(encodedData), c => c.charCodeAt(0)));
        const data = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(ProcedureResultsPrintData_$reflection(), undefined, undefined)), json);
        return (data.tag === 1) ? undefined : data.fields[0];
    }
    catch (matchValue) {
        return undefined;
    }
}

function StepElementPrint(props) {
    let elems_2, elems_1;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "py-3", "border-b", "border-gray-200", "last:border-b-0"])], (elems_2 = [reactElement("div", {
        className: join(" ", ["w-48", "font-semibold", "text-gray-700", "flex-shrink-0"]),
        children: props.Element.Label,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow"])], (elems_1 = toList(delay(() => {
        let elems;
        const matchValue = props.Element.Type;
        switch (matchValue) {
            case "TextBlock":
                return singleton(reactElement("div", {
                    className: join(" ", ["text-gray-600", "italic"]),
                    children: props.Element.Label,
                }));
            case "Signature": {
                const matchValue_1 = props.Element.SignatureUrl;
                if (matchValue_1 == null) {
                    return singleton(reactElement("div", {
                        className: join(" ", ["border-b", "border-gray-400", "h-10"]),
                    }));
                }
                else {
                    const url = matchValue_1;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["border-b", "border-gray-400", "pb-1"])], (elems = [reactElement("img", {
                        className: join(" ", ["h-16"]),
                        src: url,
                    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
                }
            }
            default:
                return singleton(reactElement("div", {
                    className: join(" ", ["text-gray-800"]),
                    children: defaultArg(props.Element.Value, "-"),
                }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function StepPrint(props) {
    let elems_2, elems, elems_1;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-6", "break-inside-avoid"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "items-center", "px-4", "py-3", "bg-gray-100", "border", "border-gray-300", "border-b-0"])], (elems = [reactElement("h3", {
        className: join(" ", ["font-semibold", "text-base"]),
        children: props.Step.Name,
    }), reactElement("span", {
        className: join(" ", toList(delay(() => append(singleton("text-xs"), delay(() => append(singleton("px-2"), delay(() => append(singleton("py-1"), delay(() => append(singleton("rounded"), delay(() => (props.Step.IsCompleted ? append(singleton("bg-green-100"), delay(() => singleton("text-green-800"))) : append(singleton("bg-gray-200"), delay(() => singleton("text-gray-600"))))))))))))))),
        children: props.Step.IsCompleted ? t("procedure.completed") : t("procedure.not_completed"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["border", "border-gray-300", "border-t-0", "px-4", "py-2"])], (elems_1 = toList(delay(() => (isEmpty(props.Step.Elements) ? singleton(reactElement("div", {
        className: join(" ", ["text-gray-400", "italic", "py-2"]),
        children: t("procedure.no_results"),
    })) : map((element) => createElement(StepElementPrint, {
        Element: element,
    }), props.Step.Elements)))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function ProcedureResultsPrintView(props) {
    let elems_6, elems, elems_4, elems_5;
    const t = useTranslation()[0];
    const logoUrl = (Variant.tag === 1) ? "assets/images/inventory-one-logo.png" : "assets/images/mwk_logo.png";
    const matchValue = decodeData(props.Data);
    if (matchValue != null) {
        const data = matchValue;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-2xl", "mx-auto", "p-8", "bg-white"])], (elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "mb-8"])], (elems = toList(delay(() => append(singleton(reactElement("img", {
            className: join(" ", ["w-60", "mb-4"]),
            src: logoUrl,
        })), delay(() => append(singleton(reactElement("h1", {
            className: join(" ", ["text-2xl", "font-bold", "text-center"]),
            children: data.TemplateName,
        })), delay(() => (!isNullOrWhiteSpace(data.TemplateDescription) ? singleton(reactElement("p", {
            className: join(" ", ["text-gray-600", "text-center", "mt-2"]),
            children: data.TemplateDescription,
        })) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["mb-6"])], (elems_4 = toList(delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "border-t", "border-gray-300", "py-3"])], (elems_1 = [reactElement("div", {
                className: join(" ", ["w-48", "font-semibold"]),
                children: t("procedure.start_date"),
            }), reactElement("div", {
                children: data.StartDate,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let matchValue_1, endDate, elems_2;
                return append((matchValue_1 = data.EndDate, (matchValue_1 == null) ? (empty()) : ((endDate = matchValue_1, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "border-t", "border-gray-300", "py-3"])], (elems_2 = [reactElement("div", {
                    className: join(" ", ["w-48", "font-semibold"]),
                    children: t("procedure.end_date"),
                }), reactElement("div", {
                    children: endDate,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))))))), delay(() => {
                    let elems_3;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "border-t", "border-b", "border-gray-300", "py-3"])], (elems_3 = [reactElement("div", {
                        className: join(" ", ["w-48", "font-semibold"]),
                        children: t("general.status"),
                    }), reactElement("div", {
                        children: data.State,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("div", createObj(singleton_1((elems_5 = toList(delay(() => map((step) => createElement(StepPrint, {
            Step: step,
        }), data.Steps))), ["children", reactApi.Children.toArray(Array.from(elems_5))]))))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
    }
    else {
        return reactElement("div", {
            className: join(" ", ["p-8", "text-center", "text-red-600"]),
            children: t("general.a_error_occured"),
        });
    }
}

